import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminExamsDetail = {
  pageTitle: "試験詳細",
  notFound: "該当する試験が見つかりません。",
  subtitleCode: "試験コード {code}",
  sections: {
    basicInfo: "基本情報",
    config: "試験設定",
    candidates: "受験者一覧",
    attempts: "作答記録",
    environments: "環境インスタンス",
    submissions: "コード提出記録",
    scores: "採点履歴",
  },
  drawers: {
    editTitle: "試験を編集",
    assignTitle: "受験者を割り当て",
    customFieldsTitle: "試験カスタム項目",
  },
  candidateAssignHint:
    "ここでは割り当ての追加のみ行い、既存の割り当ては上書きしません。割り当て済み受験者の削除は受験者一覧で個別に行ってください。",
  candidateRequired: "少なくとも 1 人の受験者を選択してください",
  candidateLabel: "受験者",
  actions: {
    publishScores: "成績公開",
    publish: "公開",
    startNow: "すぐ開始",
    start: "開始",
    end: "終了",
    archive: "アーカイブ",
    exportRuntime: "結果をエクスポート",
    exportScores: "採点明細をエクスポート",
    assignCandidates: "受験者を割り当て",
    viewAttemptDetail: "表示",
    removeCandidate: "削除",
  },
  messages: {
    candidatesUpdated: "受験者の割り当てを更新しました",
    examUpdated: "試験情報を更新しました",
    examDeleted: "試験を削除しました",
    candidateRemoved: "受験者を試験から削除しました",
    scorePublished: "成績を公開しました",
    statusUpdated: "試験状態を {action} に更新しました",
    archivedReadonly: "アーカイブ済み試験は読み取り専用のため編集できません",
    publishScoresUnavailable: "手動成績公開は利用できません：{reason}",
    publishScoresAutoMode: "現在は成績自動公開のため、手動公開は不要です。",
    publishScoresExamNotEnded: "試験終了後にのみ手動で成績を公開できます。",
    publishScoresAlreadyPublished: "成績はすでに公開済みです。再公開は不要です。",
    customFieldsSaved: "試験カスタム項目を保存しました",
    saveFailed: "保存に失敗しました",
  },
  labels: {
    assignedStatus: "割り当て済み",
    anomalyNormal: "正常",
    currentPaperVersion: "現行バージョン",
    historyPaperVersion: "履歴バージョン",
    scoreSourceAuto: "自動採点",
    scoreSourceEnvironment: "環境採点",
    scoreSourceJudge: "判定採点",
    scoreSourceAi: "AI 採点",
    scoreSourceManual: "手動採点",
    scoreSourceReview: "レビュー採点",
    unknownSource: "不明なソース",
    commentAutoObjectiveScoring: "システムによる客観問題の自動採点",
  },
  actionsExtra: {
    viewPaper: "試験用紙を表示",
    checkPaperUpdates: "更新を確認",
    customFields: "カスタム項目",
  },
  tabs: {
    rules: "ルール設定",
    candidates: "受験者作答",
    analysis: "試験分析",
    monitoring: "実行監視",
    scores: "採点履歴",
  },
  ruleGroups: {
    entry: "試験入室",
    submission: "提出と採点",
    runtime: "実行ポリシー",
  },
  table: {
    candidate: "受験者",
    assignmentStatus: "割り当て状態",
    assignedAt: "割り当て日時",
    attempt: "作答",
    attemptId: "作答ID",
    candidateId: "受験者 ID",
    score: "得点",
    anomaly: "異常",
    time: "時刻",
    instanceId: "インスタンス ID",
    submissionId: "提出 ID",
    judgeResult: "判定結果",
    submittedAt: "提出日時",
    scoreRecordId: "記録 ID",
    source: "ソース",
    comment: "コメント",
    includedInFinal: "最終得点に含める",
  },
  candidateTable: {
    startedAt: "開始時刻",
    submittedAt: "提出時刻",
    usedMinutes: "所要時間",
    usedMinutesValue: "{minutes} 分",
    anomaly: "異常",
    objectiveSubjectiveScore: "客観 {objective} / 主観 {subjective}",
  },
  basicInfo: {
    status: commonShortNouns.status,
    paperTitle: "試験用紙名",
    paperCode: "試験用紙コード",
    paperVersionCode: "試験用紙バージョンコード",
    paperVersionId: "試験用紙バージョン ID",
    entryCode: "入口コード",
    entrySubdomain: "入口サブドメイン",
    duration: "試験時間",
    actualEndTime: "実際の終了時刻",
    publishScoreMode: "成績公開方式",
    resultVisibility: "成績表示範囲",
    answerVisibility: "解答表示範囲",
    allowLateEntry: "遅刻入室を許可",
    lateEntryGraceMinutes: "最大遅刻許容時間",
    allowReentry: "中断後の再入室を許可",
    allowMultipleSubmit: "複数回提出を許可",
    maxAttemptCount: "最大作答回数",
    candidateEnvironmentMaxActive: "受験者ごとの同時コンテナ上限",
    candidateEnvironmentMaxTotal: "受験者ごとのコンテナ作成回数上限",
    createdAt: commonShortFieldLabels.createdAt,
  },
  summary: {
    candidates: "割り当て済み受験者：{count}",
    attempts: "作答記録：{count}",
    environments: "環境インスタンス：{count}",
    submissions: "コード提出：{count}",
    anomalies: "異常作答：{count}",
    scorePublished: "成績公開済み：{value}",
    scorePublishedAt: "公開日時：{value}",
  },
  filters: {
    showAnomaliesOnly: "異常作答のみ表示",
    attemptStatus: "状態で絞り込み",
    candidate: "受験者で絞り込み",
    environmentStatus: "環境状態で絞り込み",
    verdict: "判定結果で絞り込み",
    scoreSource: "採点ソースで絞り込み",
    candidateByCandidate: "受験者別に絞り込み",
  },
  overviewStats: {
    expectedCandidates: "予定受験者数",
    participants: "参加者数",
    entered: "入室済み",
    submitted: "提出済み",
    anomalies: "異常人数",
  },
  timeFields: {
    hourMinuteSecond: "{hour}時間{minute}分{second}秒",
    minuteSecond: "{minute}分{second}秒",
    second: "{second}秒",
  },
  candidateMetrics: {
    attendanceRate: "出席率",
    attendanceRateHint:
      "出席率 = 入室済み / 基準人数。指定試験の基準=予定受験者数、公開試験の基準=現在の参加者数。",
    completionRate: "完了率",
    completionRateHint:
      "完了率 = 提出済み / 基準人数。指定試験の基準=予定受験者数、公開試験の基準=入室済み人数。",
    anomalyRate: "異常率",
    anomalyRateHint: "異常率 = 異常人数 / 基準人数。",
    averageScore: "平均点",
  },
  candidateFilters: {
    status: "状態で絞り込み",
    keyword: "氏名/ユーザー名で検索",
    onlyAnomalies: "異常のみ",
    onlySubmitted: "提出済みのみ",
    clear: "絞り込みをクリア",
    quickAnomalies: "異常を表示",
    quickSubmitted: "提出済みを表示",
    exportCurrent: "現在の絞り込みをエクスポート",
  },
  analysis: {
    coreMetrics: "主要指標",
    averageScore: "平均点",
    medianScore: "中央値",
    highestScore: "最高点",
    lowestScore: "最低点",
    scoreDistribution: "点数分布",
    scoreTypeStats: "設問タイプ別採点統計",
    submissionBehavior: "提出行動",
    submissionTotal: "コード提出総数",
    involvedAttempts: "関連作答数",
    avgSubmissionsPerAttempt: "平均提出回数/作答",
    scoreBucketRange: "点数帯",
    scoreBucketCount: "人数",
    scoreBucketRatio: "割合",
    scoreType: "設問タイプ",
    scoreRecordCount: "採点記録数",
    avgScore: "平均得点",
  },
  scoreSummary: {
    title: "採点履歴",
    totalRecords: "採点記録総数",
    questionTypeCount: "対象設問タイプ数",
    sourceCount: "採点ソース数",
    sourceTag: "{source}：{count} 件 (平均点: {avg})",
  },
  empty: {
    extraConfig: "拡張設定はありません",
    candidateRows: "現在の絞り込み条件に一致する受験者作答記録はありません",
    monitoring: "実行記録はありません。試験がまだ開始されていないか、関連データがありません。",
    scores: "採点記録はありません。採点または提出がまだ完了していない可能性があります。",
  },
  extraConfigLabels: {
    seedKey: "シード識別子",
    seedBundle: "シードグループ",
    typeRuntimePolicies: "設問タイプ実行ポリシー",
  },
  questionTypes: {
    singleChoice: "単一選択",
    multipleChoice: "複数選択",
    judgment: "正誤問題",
    shortAnswer: "記述式",
    code: "プログラミング",
    practical: "実技",
    attackDefense: "攻防",
  },
  runtimePolicy: {
    shuffleQuestions: "問題シャッフル {value}",
    shuffleOptions: "選択肢シャッフル {value}",
    allowSelfCheck: "自主検証 {value}",
    maxSelfCheckCount: "検証上限 {count} 回",
  },
  staffRoles: {
    sectionTitle: "試験内スタッフ役割",
    searchPlaceholder: "スタッフを検索",
    clear: "クリア",
    assign: "役割を割り当て",
    empty: "この試験に割り当てられたスタッフ役割はありません",
    assignDrawerTitle: "試験内スタッフ役割を割り当て",
    assignHint: "監考/採点役割を試験単位で割り当てます。アーカイブ済み試験は変更できません。",
    staffLabel: "スタッフ",
    staffRequired: "スタッフを選択してください",
    roleLabel: "試験内役割",
    roleRequired: "少なくとも 1 つの役割を選択してください",
    tableStaff: "スタッフ",
    tableUserStatus: "アカウント状態",
    tableRoles: "試験内役割",
    removeConfirmTitle: "この試験内役割を削除しますか？",
    removePrefix: "削除",
  },
  confirm: {
    removeCandidateTitle: "この受験者を削除しますか？",
    removeCandidateDescription: "この受験者に作答記録がある場合、バックエンドは削除を拒否します。",
    publishExamTitle: "試験を公開しますか？",
    publishExamDescription: "公開後、試験状態は公開済みになります。操作を確認してください。",
    startExamTitle: "試験を開始しますか？",
    startExamDescription: "開始後、試験は実行中になります。操作を確認してください。",
    start_nowExamTitle: "試験をすぐ開始しますか？",
    start_nowExamDescription:
      "試験は直ちに開始され、受験者はすぐに入室できます。操作を確認してください。",
    publish_scoresExamTitle: "成績を公開しますか？",
    publish_scoresExamDescription:
      "公開後、受験者は自分の試験成績を確認できるようになります。操作を確認してください。",
    endExamTitle: "試験を終了しますか？",
    endExamDescription: "試験終了後、受験者は解答を続けられません。操作を確認してください。",
    archiveExamTitle: "試験をアーカイブしますか？",
    archiveExamDescription:
      "試験をアーカイブすると、関連データはロックされます。操作を確認してください。",
    deleteExamTitle: "試験を削除しますか？",
    deleteExamDescription: "削除できるのは下書き試験のみです。削除後は元に戻せません。",
  },
};
